import React, { useState } from 'react';
import { 
  brandBlue, 
  textDark, 
  background, 
  border, 
  white, 
  container,
  heroPadding
} from '../styles/theme';

function ImmersiveSubtitles() {
  const [selectedContent, setSelectedContent] = useState('biester_anger');

  const contentOptions = {
    biester_anger: {
      name: 'Biester | Anger Scene',
      url: 'https://demo.phont.cloud.insysvt.com/video/68c2868b809ffdb850d076bb',
      description: 'Intense anger scene with dynamic emotional subtitles'
    },
    soko_joy: {
      name: 'SOKO LINZ | Joy Scene',
      url: 'https://demo.phont.cloud.insysvt.com/video/68c2856a809ffdb850d076ba',
      description: 'Joyful moment with uplifting subtitle styling'
    },
    biester_joy: {
      name: 'Biester | Joy Scene',
      url: 'https://demo.phont.cloud.insysvt.com/video/68c2831a809ffdb850d076b8',
      description: 'Happy scene with bright, energetic subtitles'
    },
    biester_sadness_fear: {
      name: 'Biester | Sadness Fear Scene',
      url: 'https://demo.phont.cloud.insysvt.com/video/68c282fd809ffdb850d076b7',
      description: 'Emotional scene with subtle, empathetic subtitle styling'
    },
    school_anger: {
      name: 'School of Champions | Anger Scene',
      url: 'https://demo.phont.cloud.insysvt.com/video/68c1ce39809ffdb850d076b6',
      description: 'Intense confrontation with bold, impactful subtitles'
    }
  };

  return (
    <div className="min-h-screen bg-white" style={{ color: textDark }}>
      {/* Hero */}
      <section className={`mx-auto ${container} px-6 ${heroPadding}`}>
        <img src="https://www.bigbluemarble.com/img/marble.svg" alt="" aria-hidden="true" role="presentation" className="pointer-events-none select-none absolute inset-0 -z-10 opacity-10 object-cover" />
        <div className="grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-7">
            <h1 className="text-3xl md:text-5xl font-bold leading-tight" style={{ color: brandBlue }}>
              Immersive subtitles
              <span className="block text-lg md:text-2xl mt-3 font-normal" style={{ color: textDark, opacity: 0.85 }}>AI-powered emotion detection for enhanced subtitles.</span>
            </h1>
            <p className="mt-4 max-w-2xl" style={{ opacity: 0.9 }}>
              Transform your content with intelligent subtitles that adapt to emotional context. Our AI analyzes audio sentiment, facial expressions, and dialogue tone to create visually expressive subtitles that enhance viewer engagement and accessibility.
            </p>
            <div className="mt-6 flex flex-wrap gap-3 text-xs">
              {['Emotion Detection','Dynamic Styling','Sentiment Analysis','Visual Enhancement'].map((t,i)=> (
                <span key={i} className="rounded-full px-3 py-1 border" style={{ borderColor: brandBlue, color: brandBlue }}>
                  {t}
                </span>
              ))}
            </div>
          </div>
          <div className="md:col-span-5">
            <div className="relative rounded-2xl overflow-hidden shadow-lg" style={{ border: `1px solid ${border}` }}>
              <div className="aspect-video">
                <img src="/images/EmoTitle_poster.png" alt="Video Upscaling Poster" className="h-full w-full object-contain" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Demo Section */}
      <div className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-12 gap-8 items-start">
            {/* Column 1: Emotion Controls */}
            <div className="col-span-4">
              <div className="rounded-2xl overflow-hidden shadow-lg h-fit" style={{ border: `1px solid ${border}` }}>
                <div className="p-4" style={{ background: background, borderBottom: `1px solid ${border}` }}>
                  <h3 className="font-semibold" style={{ color: brandBlue }}>Emotion Configuration</h3>
                </div>
                <div className="p-6 space-y-6">
                  {/* Content Selection */}
                  <div>
                    <label className="block text-sm font-medium mb-2" style={{ color: textDark }}>
                      Content Type
                    </label>
                    <select 
                      value={selectedContent}
                      onChange={(e) => setSelectedContent(e.target.value)}
                      className="w-full p-3 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      style={{ borderColor: border }}
                    >
                      {Object.entries(contentOptions).map(([key, content]) => (
                        <option key={key} value={key}>
                          {content.name}
                        </option>
                      ))}
                    </select>
                    <p className="text-sm mt-2" style={{ opacity: 0.7 }}>
                      {contentOptions[selectedContent].description}
                    </p>
                  </div>

                  <button 
                    className="w-full px-6 py-3 rounded-lg font-medium" 
                    style={{ background: brandBlue, color: white }}
                    onClick={() => window.open(contentOptions[selectedContent].url, '_blank')}
                  >
                    Load Video
                  </button>
                </div>
              </div>
            </div>

            {/* Column 2: Video with Emotional Subtitles */}
            <div className="col-span-8">
              <div className="rounded-2xl overflow-hidden shadow-lg h-fit" style={{ border: `1px solid ${border}` }}>
                <div className="p-4" style={{ background: background, borderBottom: `1px solid ${border}` }}>
                  <h3 className="font-semibold" style={{ color: brandBlue }}>
                    Video with Emotional Subtitles
                  </h3>
                  <p className="text-sm mt-1" style={{ opacity: 0.8 }}>
                    Enhanced emotional subtitles
                  </p>
                </div>
                <div className="p-6">
                  <img 
                    src="/images/phont-player.png"
                    alt="Immersive Subtitles Demo"
                    className="w-full h-80 rounded-lg object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default ImmersiveSubtitles;

